import { gql } from 'apollo-angular';

/**
 * Registry of named GraphQL queries for use by DynamicFormDataSourceService.
 *
 * Key   – matches IDataSourceConfiguration.query (e.g. "getAllLoans")
 * Value – Apollo DocumentNode produced by the gql template tag.
 *
 * Add a new entry here whenever a FormTemplate DataSource uses
 * sourceType: 'graphql' with a new query name.
 */
export const GQL_QUERY_REGISTRY: Record<string, any> = {

  /**
   * Fetches all loans (active + inactive).
   * Matches DataSource configuration: { "query": "getAllLoans" }
   *
   * Shape expected by LoanAmountGridComponent:
   *   { loans: Array<{ name, status, isActive, dealName }> }
   *
   * ⚠ Adjust the field list to match your actual GraphQL schema.
   */
  getAllLoans: gql`
    query GetAllLoans {
      loans {
        name
        status
        isActive
        dealName
      }
    }
  `,
};
